const initialState = {
    deviceManagedStatusArr: [],
    domainSyncStatusArr: [],
    connectorSyncStatusArr: []
}

export default function filtersReducer(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_DEVICE_MANAGED_STATUS':
            return { ...state, deviceManagedStatusArr: action.data.deviceManagedStatusArr };

        case 'UPDATE_DOMAIN_SYNC_STATUS':
            return { ...state, domainSyncStatusArr: action.data.domainSyncStatusArr };

        case 'UPDATE_CONNECTOR_SYNC_STATUS':
            return { ...state, connectorSyncStatusArr: action.data.connectorSyncStatusArr };

        default:
            return state;
    }
}

function upsertStatus(arr, matchFn, newItem) {
    const index = arr.findIndex(matchFn);
    if (index !== -1) {
        const updated = [...arr];
        updated[index] = newItem;
        return updated;
    }
    return [...arr, newItem];
}



export function updateDeviceManagedStatus(deviceId, managedStatus) {
    const store = window.store;
    if (!store) return;

    const currentStatus = store.getState().enrollment.deviceManagedStatusArr;
    const deviceStatus = { id: parseInt(deviceId), status: managedStatus };

    const newArr = upsertStatus(currentStatus, obj => obj.id === deviceStatus.id, deviceStatus);

    store.dispatch({
        type: 'UPDATE_DEVICE_MANAGED_STATUS',
        data: { deviceManagedStatusArr: newArr }
    });
}

export function updateDomainSyncStatus(domainId, syncStatus) {
    const store = window.store;
    if (!store) return;

    const currentStatus = store.getState().enrollment.domainSyncStatusArr;
    const connectorStatus = { id: parseInt(domainId), status: syncStatus };

    const newArr = upsertStatus(currentStatus, obj => obj.id === connectorStatus.id, connectorStatus);

    store.dispatch({
        type: 'UPDATE_DOMAIN_SYNC_STATUS',
        data: { domainSyncStatusArr: newArr }
    });
}
export function updateConnectorSyncStatus(connectorId, syncStatus) {
    const store = window.store;
    if (!store) return;

    const currentStatus = store.getState().enrollment.connectorSyncStatusArr;
    const connectorStatus = { id: parseInt(connectorId), status: syncStatus };

    const newArr = upsertStatus(currentStatus, obj => obj.id === connectorStatus.id, connectorStatus);

    store.dispatch({
        type: 'UPDATE_CONNECTOR_SYNC_STATUS',
        data: { connectorSyncStatusArr: newArr }
    });
}

